'use strict';

/**
 * Automatically closes a toaster notification after 15 seconds
 *
 * @param {jQuery} $closeBtn - jQuery object representing the toaster's close button
 * @returns {number} Timeout ID for potential cancellation
 */
function closeToasterTimeout($closeBtn) {
    return setTimeout(function () {
        $closeBtn.trigger('click');
    }, window.brandSettings.toasterDuration || 15000);
}

/**
 * Sets the events for toaster close timeout
 *
 * @param {jQuery} $toaster - jQuery object representing the toaste
 */
const closeToasterEvents = function ($toaster) {
    const $closeBtn = $toaster.find('.close, .close-toaster');
    let closeTimeout = closeToasterTimeout($closeBtn);

    $toaster.off('mouseenter').on('mouseenter', function () {
        clearTimeout(closeTimeout);
    });
    $toaster.off('mouseleave').on('mouseleave', function () {
        closeTimeout = closeToasterTimeout($closeBtn);
    });
};

/**
 * Opens a toaster notification by making it visible and triggering the animation
 * @param {jQuery} $toaster - The jQuery object representing the toaster element to open
 */
const openToaster = function ($toaster) {
    $toaster.removeClass('d-none');
    setTimeout(function () {
        $toaster.addClass('toaster-animate');
    }, 0);
};

/**
 * Closes a toaster notification by triggering the closing animation and then hiding it
 * @param {jQuery} $toaster - The jQuery object representing the toaster element to close
 */
const closeToaster = function ($toaster) {
    $toaster.addClass('closing');
    setTimeout(() => {
        $toaster.removeClass('closing toaster-animate').addClass('d-none');
    }, 200);
};

/**
 * Initializes the toaster functionality by setting up click event listeners
 * @param {jQuery} $openLink - The jQuery object representing the element that opens the toaster
 * @param {jQuery} $closeLink - The jQuery object representing the element that closes the toaster
 * @param {jQuery} $toaster - The jQuery object representing the toaster element to control
 */
const initToaster = function ($openLink, $closeLink, $toaster) {
    $openLink.on('click', function () {
        openToaster($toaster);
    });

    $closeLink.on('click', function () {
        closeToaster($toaster);
    });

    closeToasterEvents($toaster);
};

module.exports = {
    initToaster,
    openToaster,
    closeToaster,
    closeToasterEvents,
    closeToasterTimeout,
};
